
import { RevCarousel } from '@ds/components/Carousel'
import { RevCarouselController } from '@ds/components/CarouselController'
import { RevIllustration } from '@ds/components/Illustration'
import { RevMediaViewer } from '@ds/components/MediaViewer'
import { openModal } from '@ds/components/ModalBase'
import { mapGetters } from 'vuex'

import { COUNTRIES, MODAL_NAMES } from '@config/constants'
import Precipitation from '@core/components/Precipitation/Precipitation'

import translations from './Gallery.translations'

export default {
  components: {
    RevCarousel,
    RevCarouselController,
    RevIllustration,
    RevMediaViewer,
    Precipitation,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    allowMarketingImages: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    translations: () => translations,
    mediaViewerName: () => MODAL_NAMES.PRODUCT.MEDIA_VIEWER,

    ...mapGetters({
      country: 'config/country',
    }),

    tracking() {
      return { name: 'product' }
    },

    controllerVariant() {
      return {
        desktop: 'thumbnails',
        mobile: 'dots',
      }
    },

    controllerPosition() {
      return {
        Lg: 'left',
        Sm: 'bottom',
      }
    },

    carouselImages() {
      const images =
        this.allowMarketingImages && this.country === COUNTRIES.US
          ? [
              ...this.images,
              {
                url: this.$static('/img/product/tech-reborn/tech-reborn.jpg'),
                alt: '',
              },
            ]
          : this.images

      return images.map((image) => ({
        src: image.url,
        alt: image.alt,
      }))
    },
  },
  methods: {
    shouldLoadEagerly(index) {
      return index === 0 ? 'eager' : 'lazy'
    },
    handleCarouselClick() {
      this.openMediaViewer()
    },
    openMediaViewer() {
      openModal(this.mediaViewerName)
    },
  },
}
